import { FunctionComponent, useId } from "react";
import { Radio } from "../radio/Radio.component";
import { IRadioGroupProps } from "./interfaces/IRadioGroupProps";
import { Orientation } from "./enums/Orientation";
import "./styles/radio-group.css";

export const RadioGroup: FunctionComponent<IRadioGroupProps> = (props) => {
    const groupId = useId();
    const orientation = props.orientation !== undefined ? props.orientation : Orientation.Vertical;
    const name = props.name !== undefined ? props.name : groupId;

    return (
        <div className="cui-radio-group" role="radiogroup" aria-label={props.label} style={{ flexDirection: orientation }}>
            {props.items.map((item) => (
                <Radio
                    id={item.id}
                    key={item.id}
                    name={name}
                    value={item.value}
                    isRequired={props.isRequired}
                    isDisabled={props.isDisabled}
                    isChecked={props.value === item.value}
                    onChange={props.onChange}>
                    {item.label}
                </Radio>
            ))}
        </div>
    );
};
